import {
  GENERATED_HTML,
  LEAD_FORMS,
  LOADING,
} from "../actionType/webToLeadType";
import { webToLead } from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  postAuthMethod,
  patchAuthMethod,
} from "../services/HttpServices";

export const deleteLeadForm = (payload) => (dispatch) => {
  return deleteAuthMethod(`${webToLead}/${payload?.id}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const updateLeadForm = (payload) => (dispatch) => {
  return patchAuthMethod(webToLead, payload?.id, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const createLeadForm = (payload) => (dispatch) => {
  return postAuthMethod(webToLead, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getLeadForms = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`${webToLead}?${payload}`)
    .then((res) => {
      dispatch({
        type: LEAD_FORMS,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const generateHtml = (id, isScript) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`/api/${id}/${isScript ? "js-script" : "html-form"}`)
    .then((res) => {
      dispatch({
        type: GENERATED_HTML,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const emptyGeneratedHtml = () => (dispatch) => {
  dispatch({
    type: GENERATED_HTML,
    payload: null,
  });
};

export const getFormDetailsById = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`${webToLead}/${id}`)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};
